import { Injectable } from '@angular/core';
import { BulkDeleteServiceInput, BulkDeleteServiceMutation } from '../API.service';
import { API, graphqlOperation } from 'aws-amplify';

@Injectable({
  providedIn: 'root'
})
export class BulkDeleteService {

  constructor() { }

  // export type BulkDeleteServiceInput = {
  //   type?: ModelType | null;
  //   ids?: Array<string | null> | null;
  // };


  // export enum ModelType {
  //   CLIENT = "CLIENT",
  //   INVOICE = "INVOICE",
  //   FOLDER = "FOLDER",
  //   CODEBOOK = "CODEBOOK",
  //   TEMPLATE = "TEMPLATE"
  // }

  async BulkDeleteService(
    input?: BulkDeleteServiceInput
  ): Promise<BulkDeleteServiceMutation> {
    const statement = `mutation BulkDeleteService($input: BulkDeleteServiceInput) {
        bulkDeleteService(input: $input) {
          __typename
          success
          message
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (input) {
      gqlAPIServiceArguments.input = input;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <BulkDeleteServiceMutation>response.data.bulkDeleteService;
  }
}
